import React from "react";
import "./Footer.scss";
import {FaLocationArrow, FaMobileAlt,FaEnvelope} from "react-icons/fa";
import Payment from "../../assets/payments.png";
import footerimg from "../../assets/logo/book-now.png"

  // ... add more style rules as needed
const Footer = () => {
    return(
    <footer className="footer">
        <div className="row d-flex footer-content">            
            <div className="col-md-4">
                <div className="title">Contact</div>
                <div className="c-item">
                    <FaLocationArrow style={{fontSize:'18px',color:'#F1CF69'}}/>
                    <div className="text">
                        NH47, Indore - Dhar Rd, Machal (M.P.)
                    </div>
                </div>
                <div className="c-item">
                    <FaMobileAlt style={{fontSize:'18px',color:'#F1CF69'}}/>
                    <div className="text">
                       Phone : +91-8889881928, +91-8889881021
                    </div>
                </div>
                <div className="c-item">
                    <FaEnvelope style={{fontSize:'18px',color:'#F1CF69'}}/>
                    <div className="text">
                       Email: thegrandmachal@gmail.com
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="title">Quick Links</div>
                <div className="text">Home</div>
                <div className="text">About</div>
                <div className="text">Terms & Conditions</div>
                <div className="text">Privacy Policy</div>
            </div>
            <div className="col-md-4">
                <div className="title">Location</div>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3681.4857398190566!2d75.66760667530342!3d22.672954779420355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396255e10d32d35f%3A0x8793a783d686397c!2sThe%20Grand%20Machal%20Resorts%20%26%20Clubs!5e0!3m2!1sen!2sin!4v1750772900797!5m2!1sen!2sin" width={320} height={150} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>

{/* /*------------------------------ Footer Whatsapp Fixed Image Start ----------------------- */}
    <div className="row d-flex">
        <div className="">
            <a href="https://wa.me/918889881928" className="whatsapp-float" target="_blank" title="Chat with us on WhatsApp" aria-label="Chat on WhatsApp">
                <svg xmlns="http://www.w3.org/2000/svg" className="whatsapp-icon" viewBox="0 0 32 32" fill="#ffffff">
                    <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.635.955 5.05 2.547 6.963L5 29l7.279-1.916A11.935 11.935 0 0016 27c6.627 0 12-5.373 12-12S22.628 3 16.001 3zm.014 21.733a9.517 9.517 0 01-4.822-1.324l-.345-.205-4.325 1.138 1.15-4.205-.226-.347a9.51 9.51 0 01-1.458-5.06c0-5.26 4.28-9.541 9.543-9.541 5.258 0 9.542 4.28 9.542 9.541 0 5.26-4.284 9.542-9.542 9.542zm5.335-7.159c-.29-.144-1.714-.846-1.98-.942-.265-.096-.46-.144-.656.144-.194.288-.75.94-.92 1.133-.17.192-.34.216-.63.072-.29-.145-1.224-.45-2.33-1.437-.86-.767-1.44-1.714-1.607-2.002-.17-.288-.018-.444.128-.588.13-.13.29-.337.434-.505.15-.17.198-.288.298-.48.098-.192.048-.36-.024-.504-.072-.144-.656-1.585-.899-2.173-.238-.572-.48-.494-.656-.504-.17-.007-.36-.009-.552-.009a1.065 1.065 0 00-.774.36c-.265.288-1.01.984-1.01 2.4s1.034 2.78 1.178 2.97c.144.192 2.034 3.12 4.93 4.38.688.297 1.226.474 1.645.607.69.22 1.317.188 1.812.114.552-.082 1.714-.7 1.957-1.379.24-.672.24-1.248.168-1.379-.07-.13-.265-.21-.552-.36z"/>
                </svg>
            </a>
        </div>
        <div className="">
            <a href="https://www.instagram.com/thegrandmachal/?hl=en" className="insta-float" target="_blank" title="Follow us on Instagram" aria-label="Follow on Instagram">
               <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    width="40"
                    height="40"
                    className="insta-icon"
                    >
                    <defs>
                        <radialGradient id="insta-gradient" cx="30%" cy="107%" r="150%" fx="30%" fy="107%">
                        <stop offset="0%" stop-color="#fdf497"/>
                        <stop offset="5%" stop-color="#fdf497"/>
                        <stop offset="45%" stop-color="#fd5949"/>
                        <stop offset="60%" stop-color="#d6249f"/>
                        <stop offset="90%" stop-color="#285AEB"/>
                        </radialGradient>
                    </defs>
                        <path
                            fill="url(#insta-gradient)"
                            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9S160.5 
                            370.8 224.1 370.8 339 319.5 339 
                            255.9 287.7 141 224.1 141zm0 
                            188.6c-40.6 0-73.7-33-73.7-73.7s33-73.7 
                            73.7-73.7 73.7 33 73.7 
                            73.7-33.1 73.7-73.7 73.7zm146.4-194.3c0 
                            14.9-12 26.8-26.8 
                            26.8s-26.8-12-26.8-26.8 12-26.8 
                            26.8-26.8 26.8 12 
                            26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.8-36.3-94.3S366 
                            8.3 330.1 
                            6.6C294.1 4.9 153.9 4.9 117.9 
                            6.6 82 8.3 50.1 16.5 23.6 
                            43S8.3 82 6.6 117.9C4.9 153.9 
                            4.9 294.1 6.6 
                            330.1c1.7 35.9 9.9 67.8 36.3 
                            94.3s58.4 34.6 94.3 
                            36.3c35.9 1.7 176.1 1.7 212.1 
                            0 35.9-1.7 67.8-9.9 
                            94.3-36.3s34.6-58.4 
                            36.3-94.3c1.7-35.9 
                            1.7-176.1 0-212.1zM398.8 
                            388c-7.8 19.6-22.9 34.7-42.6 
                            42.6-29.5 11.7-99.5 9-132.1 
                            9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 
                            9-132.1c7.8-19.6 22.9-34.7 
                            42.6-42.6 29.5-11.7 99.5-9 
                            132.1-9s102.7-2.6 132.1 
                            9c19.6 7.8 34.7 22.9 
                            42.6 42.6 11.7 29.5 9 
                            99.5 9 132.1s2.6 102.7-9 
                            132.1z"
                        />
                    </svg>
            </a>
        </div>
    </div>


{/* /*------------------------------ Footer Whatsapp Fixed Image End ----------------------- */        
/*------------------------------ Footer Left Side Fixed Image Start ----------------------- */}
        <div>
            <a href="" class="footerimg" target="_blank" title="">
                <img src={footerimg} alt="booknow" className="footer-icon"/>
            </a>
        </div>
{/* /*------------------------------ Footer Left Side Fixed Image End ----------------------- */}
        <div className="bootom-bar">
            <div className="bottom-bar-content">
                <div className="text">
                    Copyright © 2025 by The Grand Machal Resorts & Clubs Pvt. Ltd
                </div>
                <img src={Payment}/>
            </div>
        </div>
    </footer>

    );
};

export default Footer;
